let numeral = require('numeral');
let _ = require('lodash');

module.exports = function (context, options) {
    const number = parseFloat(context);
    let value = _.isNumber(number) && _.isFinite(number) ? number : 0;
    const format = options.hash.format || '0,0';
    if (format === '0a' && value > 9999) {
        const lang = numeral.language();
        numeral.language('en');
        value = numeral(value).format('0a');
        numeral.language(lang);
        return value;
    }
    return numeral(value).format(format, Math.floor);
};



// WEBPACK FOOTER //
// ./src/scripts/core/templates/templates/numeral.js